var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sel"},[_c('commonTemplate',{attrs:{"propData":_vm.propData,"defaultVal":{ value: _vm.finalSelect },"tool":_vm.tool},on:{"upData":_vm.upData},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var attr = ref.attr;
var change = ref.change;
var form = ref.form;
return [_c('el-select',_vm._b({attrs:{"placeholder":"请选择"},on:{"change":function($event){return change(
            typeof form[_vm.propDataCopy.key] == 'string'
              ? form[_vm.propDataCopy.key].length == 0
                ? []
                : [form[_vm.propDataCopy.key]]
              : form[_vm.propDataCopy.key]
          )}},model:{value:(form[_vm.propDataCopy.key]),callback:function ($$v) {_vm.$set(form, _vm.propDataCopy.key, $$v)},expression:"form[propDataCopy.key]"}},'el-select',attr,false),_vm._l((_vm.selectArr),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.value,"value":item.key}})}),1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }